import {
  getSalesInvoicesandsales,
  getFrequentlysold,
  getCustomers2,
  getCustomerById,
  createCustomer,
  updateCustomer,
  deleteCustomer,
  getCustomersSummary,
  getTopCustomers,
  getCustomersWithUnpaidAmounts,
  getCustomerFullDetails,
  getCustomersByUnpaidAmount,
  getMostActiveCustomers,
  deleteProduct,
  getVariance,
  getUserrole,
  updateInvoiceandSales,
  deleteInvoiceandSales,
  submitInvoiceandSales,
  postCustomerPayment,
  getSumSalesInvoicesandsales,
  getSumexpenses,
  getSalesInvoicespaymenttypes,
  getSumProfitorloss,
  getPaymentHistory,
  getPaymentHistoryCustomer,
  getProduct2,
  getStocksum,
  getProductUnit,
  getProduct3,
  getProductCategory,
  getPaymentType,
  getCustomers,
  getExpenseType,
  submitExpenses,
  submitProducts,
  updateProducts,
  updateallProducts,
  getGrossProfitorloss,
  getDailyProfitorloss,
  getDailyProfitorloss2,
  getAllexpenses,
  getMpesaBalance,
  getDailySales,
  getDailysales2,
  getDailyMpesaTransactions,
  getDailyMpesaTransactions2,
  paymentRequest,
  statusRequest,
  getMonthlyexpenses,
  getMonthlyexpenses2,
  submitExpensetype,
  deleteExpense,
  updateExpenses,
  getProduct4,
  getCashFloat,
  getCashFloatHistory,
  openCashFloat,
  closeCashFloat,
  updateCashFloat,
  deleteCashFloat,
  getCashFloatSummary,
  getCashFloatAudit,
  getTodaysCashFloat,
  getPurchases,
  getPurchaseById,
  createPurchase,
  updatePurchase,
  deletePurchase,
  getSupplierPayments,
  createSupplierPayment,
  updateSupplierPayment,
  deleteSupplierPayment,
  getStockMovements,
  getStockMovementsSummary,
  getSumPurchases,
  getAllpurchases,
  getCashFloatByBusinessDate,
  deleteSupplier,
  updateSupplier,
  createSupplier,
  getSupplierById,
  getSuppliers,
  getAllpurchases2,
  getSuppliersSummary,
  getSuppliersWithOutstandingPayments,
  getSupplierFullDetails,
  deletePurchaseItem,
} from '../apis/Loadalltabledata'
import {useQuery, useMutation} from 'react-query'

// ===============================
// SALES AND INVOICES HOOKS
// ===============================

export const useSalesInvoicesusequery = (
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date,
  itemto_order: string,
  desorasc: string,
  search_item: string,
  payment_status: any
) =>
  useQuery(
    ['salesInvoicesusequery', start_limit, paginationsize],
    () => {
      return getSalesInvoicesandsales(
        user_id,
        start_limit,
        paginationsize,
        start_date,
        end_date,
        itemto_order,
        desorasc,
        search_item,
        payment_status
      )
    },
    {
      keepPreviousData: true,
    }
  )

export const useSalesInvoicesusequeryprofitloss = (
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date,
  itemto_order: string,
  desorasc: string,
  search_item: string,
  payment_status: any
) =>
  useQuery(
    ['salesInvoicesusequery', start_limit, paginationsize],
    () => {
      return getSalesInvoicesandsales(
        user_id,
        start_limit,
        paginationsize,
        start_date,
        end_date,
        itemto_order,
        desorasc,
        search_item,
        payment_status
      )
    },
    {
      keepPreviousData: true,
    }
  )

export const useSalesInvoicesusequerypayment = (
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date,
  itemto_order: string,
  desorasc: string,
  search_item: string,
  payment_status: any
) =>
  useQuery(
    ['salesInvoicesusequerypayment', start_limit, paginationsize],
    () => {
      return getSalesInvoicesandsales(
        user_id,
        start_limit,
        paginationsize,
        start_date,
        end_date,
        itemto_order,
        desorasc,
        search_item,
        payment_status
      )
    },
    {
      keepPreviousData: true,
    }
  )

export const useSumsalesInvoicesusequery = (
  user_id: number,
  status: string,
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number
) =>
  useQuery('sumsalesInvoicesusequery', () => {
    return getSumSalesInvoicesandsales(
      Number(user_id),
      status,
      start_date,
      end_date,
      start_limit,
      paginationsize
    )
  })

export const useSumsalesInvoicesusequery2 = (
  user_id: number,
  status: string,
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number
) =>
  useQuery('sumsalesInvoicesusequery2', () => {
    return getSumSalesInvoicesandsales(
      Number(user_id),
      status,
      start_date,
      end_date,
      start_limit,
      paginationsize
    )
  })

export const useSalesInvoicespaymenttypes = (
  user_id: number,
  status: string,
  start_date: Date,
  end_date: Date,
  payment_status: any
) =>
  useQuery(
    'salesInvoicespaymenttypes',
    () => {
      return getSalesInvoicespaymenttypes(user_id, status, start_date, end_date, payment_status)
    },
    {
      keepPreviousData: true,
    }
  )

// Invoice mutations
export const useAddsalesinvoices = () =>
  useMutation((allsalesadded: any) => {
    return submitInvoiceandSales(allsalesadded)
  })

export const useDeletesalesinvoices = (invoiceid: string) =>
  useMutation('deletesalesinvoices', () => {
    return deleteInvoiceandSales(invoiceid)
  })

export const useUpdatesalesinvoices = (itemstoupdate: any) =>
  useMutation('updatesalesinvoices', () => {
    return updateInvoiceandSales(itemstoupdate)
  })

export const useCreateCustomerPayment = () =>
  useMutation((paymentData: Parameters<typeof postCustomerPayment>[0]) => {
    return postCustomerPayment(paymentData)
  })

//get payment history
export const usePaymentHistory = (invoice_id: string) => {
  return useQuery(['payment_history', invoice_id], () => getPaymentHistory(invoice_id))
}

//get payment history by customer
export const usePaymentHistoryCustomer = (customer_id: string) => {
  return useQuery(['payment_history_customer', customer_id], () =>
    getPaymentHistoryCustomer(customer_id)
  )
}

// ===============================
// EXPENSES HOOKS
// ===============================

export const useAllexpenses = (
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery(
    ['allexpensesquery', start_limit, paginationsize],
    () => {
      return getAllexpenses(
        user_id,
        start_limit,
        paginationsize,
        start_date,
        end_date,
        itemto_order,
        desorasc,
        search_item
      )
    },
    {
      keepPreviousData: true,
    }
  )

export const useDailymonthlyexpenses = (
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery(['dailymonthlyexpenses', start_limit, paginationsize], () => {
    return getMonthlyexpenses(
      Number(user_id),
      start_limit,
      paginationsize,
      start_date,
      end_date,
      itemto_order,
      desorasc,
      search_item
    )
  })

export const useDailymonthlyexpenses2 = (
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery(['dailymonthlyexpenses2', start_limit, paginationsize], () => {
    return getMonthlyexpenses2(
      Number(user_id),
      start_limit,
      paginationsize,
      start_date,
      end_date,
      itemto_order,
      desorasc,
      search_item
    )
  })

export const useSumexpenseusequery = (
  user_id: number,
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number
) =>
  useQuery('sumexpenseusequery', () => {
    return getSumexpenses(Number(user_id), start_date, end_date, start_limit, paginationsize)
  })

export const useSumexpenseusequery2 = (
  user_id: number,
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number
) =>
  useQuery('sumexpenseusequery2', () => {
    return getSumexpenses(Number(user_id), start_date, end_date, start_limit, paginationsize)
  })

export const useAllexpensetypes = () =>
  useQuery('allexpensetypes', () => {
    return getExpenseType()
  })

// Expense mutations
export const useAddexpenses = (expenseadded: any) =>
  useMutation('addexpenses', () => {
    return submitExpenses(expenseadded)
  })

export const useAddexpensetype = (expensetypeadded: any) =>
  useMutation('addexpensetype', () => {
    return submitExpensetype(expensetypeadded)
  })

export const useUpdateexpenses = (expensestoupdate: any) =>
  useMutation('updatesalesinvoices', () => {
    return updateExpenses(expensestoupdate)
  })

export const useDeleteexpense = (expensetodelete: number) =>
  useMutation('deleteexpense', () => {
    return deleteExpense(expensetodelete)
  })

// ===============================
// PROFIT AND LOSS ANALYSIS HOOKS
// ===============================

export const useSumprofitorlossusequery = (
  user_id: number,
  status: string,
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number
) =>
  useQuery('sumprofitorlossusequery', () => {
    return getSumProfitorloss(
      Number(user_id),
      status,
      start_date,
      end_date,
      start_limit,
      paginationsize
    )
  })

export const useSumprofitorlossusequery2 = (
  user_id: number,
  status: string,
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number
) =>
  useQuery('sumprofitorlossusequery2', () => {
    return getSumProfitorloss(
      Number(user_id),
      status,
      start_date,
      end_date,
      start_limit,
      paginationsize
    )
  })

export const useGrossprofitorlossusequery = (
  user_id: number,
  status: string,
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number
) =>
  useQuery(
    'grossprofitorlossusequery',
    () => {
      return getGrossProfitorloss(
        Number(user_id),
        status,
        start_date,
        end_date,
        start_limit,
        paginationsize
      )
    },
    {
      keepPreviousData: true,
    }
  )

export const useGrossprofitorlossusequery2 = (
  user_id: number,
  status: string,
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number
) =>
  useQuery(
    'grossprofitorlossusequery2',
    () => {
      return getGrossProfitorloss(
        Number(user_id),
        status,
        start_date,
        end_date,
        start_limit,
        paginationsize
      )
    },
    {
      keepPreviousData: true,
    }
  )

export const useDailyprofitorlossusequery = (
  user_id: number,
  status: string,
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery(['dailyprofitorlossusequery', start_limit, paginationsize], () => {
    return getDailyProfitorloss(
      Number(user_id),
      status,
      start_date,
      end_date,
      start_limit,
      paginationsize,
      itemto_order,
      desorasc,
      search_item
    )
  })

export const useDailyprofitorlossusequery2 = (
  user_id: number,
  status: string,
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery(['dailyprofitorlossusequery2', start_limit, paginationsize], () => {
    return getDailyProfitorloss2(
      Number(user_id),
      status,
      start_date,
      end_date,
      start_limit,
      paginationsize,
      itemto_order,
      desorasc,
      search_item
    )
  })

export const useDailysalesquery = (
  user_id: number,
  status: string,
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery(['dailysalesusequery', start_limit, paginationsize], () => {
    return getDailySales(
      Number(user_id),
      status,
      start_date,
      end_date,
      start_limit,
      paginationsize,
      itemto_order,
      desorasc,
      search_item
    )
  })

export const useDailysalesquery2 = (
  user_id: number,
  status: string,
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery(['dailysalesusequery2', start_limit, paginationsize], () => {
    return getDailysales2(
      Number(user_id),
      status,
      start_date,
      end_date,
      start_limit,
      paginationsize,
      itemto_order,
      desorasc,
      search_item
    )
  })

export const useVariance = (
  user_id: number,
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number
) =>
  useQuery(
    ['variance'],
    () => {
      return getVariance(user_id, start_date, end_date, start_limit, paginationsize)
    },
    {
      keepPreviousData: true,
    }
  )

// ===============================
// PRODUCTS AND INVENTORY HOOKS
// ===============================

export const useAllproductsandtypes = () =>
  useQuery(
    'allproductsandtypes',
    () => {
      return getProduct2()
    },
    {
      keepPreviousData: true,
    }
  )

export const useAllproducts = (
  start_limit: number,
  paginationsize: number,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery(
    ['allproducts', start_limit, paginationsize],
    () => {
      return getProduct3(start_limit, paginationsize, itemto_order, desorasc, search_item)
    },
    {
      keepPreviousData: true,
    }
  )

export const useAllproducts2 = (
  start_limit: number,
  paginationsize: number,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery(
    ['allproducts2', start_limit, paginationsize],
    () => {
      return getProduct4(start_limit, paginationsize, itemto_order, desorasc, search_item)
    },
    {
      keepPreviousData: true,
    }
  )

export const useSumstock = (
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date
) =>
  useQuery('allsumstock', () => {
    return getStocksum(start_limit, paginationsize, start_date, end_date)
  })

export const useFrequentlysold = (paginationsize: number) =>
  useQuery(
    'frequentlysold',
    () => {
      return getFrequentlysold(paginationsize)
    },
    {
      keepPreviousData: true,
    }
  )

export const useFrequentlysold2 = (paginationsize: number) =>
  useQuery(
    'frequentlysold2',
    () => {
      return getFrequentlysold(paginationsize)
    },
    {
      keepPreviousData: true,
    }
  )

export const useAllproductcategories = () =>
  useQuery(
    'allproductcategories',
    () => {
      return getProductCategory()
    },
    {
      keepPreviousData: true,
    }
  )

export const useAllproductunits = () =>
  useQuery(
    'allproductunits',
    () => {
      return getProductUnit()
    },
    {
      keepPreviousData: true,
    }
  )

// Product mutations
export const useAddproducts = (productadded: any) =>
  useMutation('addproducts', () => {
    return submitProducts(productadded)
  })

export const useUpdateproducts = (valuestoupdate: any) =>
  useMutation('updateproducts', () => {
    return updateProducts(valuestoupdate)
  })

export const useUpdateallproducts = (valuestoupdate: any) =>
  useMutation('updateallproducts', () => {
    return updateallProducts(valuestoupdate)
  })

export const useDeleteproduct = (producttodelete: number) =>
  useMutation('deleteproduct', () => {
    return deleteProduct(producttodelete)
  })

// ===============================
// STOCK MOVEMENTS HOOKS
// ===============================

export const useStockMovements = (
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date,
  product_id?: number,
  movement_type?: string,
  itemto_order?: string,
  desorasc?: string,
  search_item?: string
) =>
  useQuery(
    ['stockmovements', start_limit, paginationsize],
    () => {
      return getStockMovements(
        user_id,
        start_limit,
        paginationsize,
        start_date,
        end_date,
        product_id,
        movement_type,
        itemto_order,
        desorasc,
        search_item
      )
    },
    {
      keepPreviousData: true,
    }
  )

export const useStockMovementsSummary = (
  user_id: number,
  start_date: Date,
  end_date: Date,
  movement_type?: string
) =>
  useQuery(
    ['stockmovementssummary', user_id, movement_type],
    () => {
      return getStockMovementsSummary(user_id, start_date, end_date, movement_type)
    },
    {
      keepPreviousData: true,
    }
  )

// ===============================
// CASH FLOAT MANAGEMENT HOOKS
// ===============================

export const useCashFloat = (user_id: number, date_recorded?: string) =>
  useQuery(
    ['cashfloat', user_id, date_recorded],
    () => {
      return getCashFloat(user_id, date_recorded)
    },
    {
      keepPreviousData: true,
    }
  )

export const useTodaysCashFloat = (user_id: number, business_date?: string, options?: any) =>
  useQuery(
    ['todayscashfloat', user_id, business_date],
    () => {
      if (!business_date) {
        throw new Error('Business date is required')
      }
      return getCashFloatByBusinessDate(user_id, business_date)
    },
    {
      keepPreviousData: true,
      enabled: !!business_date,
      select: (data) => data.data,
      ...options,
    }
  )

export const useCashFloatHistory = (
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery(
    ['cashfloathistory', start_limit, paginationsize],
    () => {
      return getCashFloatHistory(
        user_id,
        start_limit,
        paginationsize,
        start_date,
        end_date,
        itemto_order,
        desorasc,
        search_item
      )
    },
    {
      keepPreviousData: true,
    }
  )

export const useCashFloatSummary = (user_id: number, start_date: Date, end_date: Date) =>
  useQuery(
    ['cashfloatsummary', user_id],
    () => {
      return getCashFloatSummary(user_id, start_date, end_date)
    },
    {
      keepPreviousData: true,
    }
  )

export const useCashFloatAudit = (
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date
) =>
  useQuery(
    ['cashfloataudit', start_limit, paginationsize],
    () => {
      return getCashFloatAudit(user_id, start_limit, paginationsize, start_date, end_date)
    },
    {
      keepPreviousData: true,
    }
  )

export const useHasOpenFloatToday = (user_id: number) =>
  useQuery(
    ['hasopenflottoday', user_id],
    () => {
      return getTodaysCashFloat(user_id)
    },
    {
      keepPreviousData: true,
      select: (data) => {
        return data?.data && data.data.length > 0 && data.data[0].status === 'OPEN'
      },
    }
  )

export const useTodaysFloatStatus = (user_id: number) =>
  useQuery(
    ['todaysfloatstatus', user_id],
    () => {
      return getTodaysCashFloat(user_id)
    },
    {
      keepPreviousData: true,
      select: (data) => {
        if (!data?.data || data.data.length === 0) return 'NO_FLOAT'
        return data.data[0].status
      },
    }
  )

// Cash float mutations
export const useOpenCashFloat = (cashFloatData: any) =>
  useMutation('opencashfloat', () => {
    return openCashFloat(cashFloatData)
  })

export const useCloseCashFloat = (cashFloatData: any) =>
  useMutation('closecashfloat', () => {
    return closeCashFloat(cashFloatData)
  })

export const useUpdateCashFloat = (cashFloatData: any) =>
  useMutation('updatecashfloat', () => {
    return updateCashFloat(cashFloatData)
  })

export const useDeleteCashFloat = (float_id: number, user_id: number, reason: string) =>
  useMutation('deletecashfloat', () => {
    return deleteCashFloat(float_id, user_id, reason)
  })

// ===============================
// PURCHASES AND PROCUREMENT HOOKS
// ===============================

export const usePurchases = (
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery(
    ['purchases', start_limit, paginationsize],
    () => {
      return getPurchases(
        user_id,
        start_limit,
        paginationsize,
        start_date,
        end_date,
        itemto_order,
        desorasc,
        search_item
      )
    },
    {
      keepPreviousData: true,
    }
  )

export const useAllPurchases = (
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery(
    ['allpurchasesquery', start_limit, paginationsize],
    () => {
      return getAllpurchases(
        user_id,
        start_limit,
        paginationsize,
        start_date,
        end_date,
        itemto_order,
        desorasc,
        search_item
      )
    },
    {
      keepPreviousData: true,
    }
  )

export const useAllPurchases2 = (
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery(
    ['allpurchasesquery2', start_limit, paginationsize],
    () => {
      return getAllpurchases2(
        user_id,
        start_limit,
        paginationsize,
        start_date,
        end_date,
        itemto_order,
        desorasc,
        search_item
      )
    },
    {
      keepPreviousData: true,
    }
  )

export const usePurchaseById = (user_id: number, purchase_id: number) =>
  useQuery(
    ['purchase', purchase_id],
    () => {
      return getPurchaseById(user_id, purchase_id)
    },
    {
      keepPreviousData: true,
    }
  )

export const useSumPurchases = (
  user_id: number,
  status: string,
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number
) =>
  useQuery('sumpurchasesusequery2', () => {
    return getSumPurchases(
      Number(user_id),
      status,
      start_date,
      end_date,
      start_limit,
      paginationsize
    )
  })

// Purchase mutations
export const useCreatePurchase = (purchaseData: any) =>
  useMutation('createpurchase', () => {
    return createPurchase(purchaseData)
  })

export const useUpdatePurchase = () =>
  useMutation(
    'updatepurchase',
    ({purchase_id, updateData}: {purchase_id: number; updateData: any}) => {
      return updatePurchase(purchase_id, updateData)
    }
  )

export const useDeletePurchase = (purchase_id: number, user_id: number) =>
  useMutation('deletepurchase', () => {
    return deletePurchase(purchase_id, user_id)
  })

export const useDeletePurchaseItem = () =>
  useMutation(
    'deletePurchaseItem',
    ({purchase_item_id, user_id}: {purchase_item_id: number; user_id: number}) => {
      return deletePurchaseItem(purchase_item_id, user_id)
    }
  )

// ===============================
// SUPPLIER MANAGEMENT HOOKS - COMPLETE
// ===============================

// Get all suppliers with pagination, sorting, search, and optional outstanding payment info
export const useSuppliers = (
  user_id: number,
  start_limit: number,
  paginationsize: number,
  itemto_order: string,
  desorasc: string,
  search_item: string,
  include_outstanding: boolean = false
) =>
  useQuery(
    [
      'suppliers',
      start_limit,
      paginationsize,
      itemto_order,
      desorasc,
      search_item,
      include_outstanding,
    ],
    () => {
      return getSuppliers(
        user_id,
        start_limit,
        paginationsize,
        itemto_order,
        desorasc,
        search_item,
        include_outstanding
      )
    },
    {
      keepPreviousData: true,
    }
  )

// Get single supplier by ID with optional purchase details
export const useSupplierById = (
  user_id: number,
  supplier_id: number,
  include_purchases: boolean = false
) =>
  useQuery(
    ['supplier', supplier_id, include_purchases],
    () => {
      return getSupplierById(user_id, supplier_id, include_purchases)
    },
    {
      keepPreviousData: true,
      enabled: !!supplier_id, // Only run if supplier_id exists
    }
  )

// Get suppliers analytics/summary - matches the backend sumsuppliers endpoint
export const useSuppliersSummary = (
  user_id: number,
  start_date: Date,
  end_date: Date,
  start_limit: number = 0,
  paginationsize: number = 10,
  payment_status: string = '%'
) =>
  useQuery(
    [
      'suppliersSummary',
      user_id,
      start_date,
      end_date,
      start_limit,
      paginationsize,
      payment_status,
    ],
    () => {
      return getSuppliersSummary(
        user_id,
        start_date,
        end_date,
        start_limit,
        paginationsize,
        payment_status
      )
    },
    {
      keepPreviousData: true,
      enabled: !!start_date && !!end_date, // Only run if dates are provided
    }
  )

// Utility Hooks for Common Supplier Operations

// Get suppliers with outstanding payments only
export const useSuppliersWithOutstandingPayments = (
  user_id: number,
  start_limit: number = 0,
  paginationsize: number = 10,
  search_item: string = ''
) =>
  useQuery(
    ['suppliersWithOutstanding', user_id, start_limit, paginationsize, search_item],
    () => {
      return getSuppliersWithOutstandingPayments(user_id, start_limit, paginationsize, search_item)
    },
    {
      keepPreviousData: true,
    }
  )

// Get supplier details with all purchase information
export const useSupplierFullDetails = (user_id: number, supplier_id: number) =>
  useQuery(
    ['supplierFullDetails', supplier_id],
    () => {
      return getSupplierFullDetails(user_id, supplier_id)
    },
    {
      keepPreviousData: true,
      enabled: !!supplier_id, // Only run if supplier_id exists
    }
  )

// Supplier mutations
export const useCreateSupplier = (supplierData: any) =>
  useMutation('createsupplier', () => {
    return createSupplier(supplierData)
  })

export const useUpdateSupplier = (supplier_id: number, updateData: any) =>
  useMutation('updatesupplier', () => {
    return updateSupplier(supplier_id, updateData)
  })

export const useDeleteSupplier = (supplier_id: number, user_id: number) =>
  useMutation('deletesupplier', () => {
    return deleteSupplier(supplier_id, user_id)
  })

// ===============================
// SUPPLIER PAYMENTS HOOKS
// ===============================

export const useSupplierPayments = (
  user_id: number,
  start_limit: number,
  paginationsize: number,
  start_date: Date,
  end_date: Date,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery(
    ['supplierpayments', start_limit, paginationsize],
    () => {
      return getSupplierPayments(
        user_id,
        start_limit,
        paginationsize,
        start_date,
        end_date,
        itemto_order,
        desorasc,
        search_item
      )
    },
    {
      keepPreviousData: true,
    }
  )

// Supplier payment mutations
export const useCreateSupplierPayment = (paymentData: any) =>
  useMutation('createsupplierpayment', () => {
    return createSupplierPayment(paymentData)
  })

export const useUpdateSupplierPayment = (payment_id: number, updateData: any) =>
  useMutation('updatesupplierpayment', () => {
    return updateSupplierPayment(payment_id, updateData)
  })

export const useDeleteSupplierPayment = (payment_id: number, user_id: number) =>
  useMutation('deletesupplierpayment', () => {
    return deleteSupplierPayment(payment_id, user_id)
  })

// ===============================
// CUSTOMER MANAGEMENT HOOKS - COMPLETE
// ===============================

// Legacy customer hook (backwards compatibility)
export const useAllcustomers = () =>
  useQuery(
    'allcustomers',
    () => {
      return getCustomers()
    },
    {
      keepPreviousData: true,
    }
  )

// Get all customers with pagination, sorting, search, and optional unpaid amounts
export const useAllcustomers2 = (
  user_id: number,
  start_limit: number,
  paginationsize: number,
  itemto_order: string,
  desorasc: string,
  search_item: string,
  include_unpaid: boolean = false
) =>
  useQuery(
    ['customers', start_limit, paginationsize, itemto_order, desorasc, search_item, include_unpaid],
    () => {
      return getCustomers2(
        user_id,
        start_limit,
        paginationsize,
        itemto_order,
        desorasc,
        search_item,
        include_unpaid
      )
    },
    {
      keepPreviousData: true,
    }
  )

// Get single customer by ID with optional invoice details
export const useCustomerById = (
  user_id: number,
  customer_id: number,
  include_invoices: boolean = false
) =>
  useQuery(
    ['customer', customer_id, include_invoices],
    () => {
      return getCustomerById(user_id, customer_id, include_invoices)
    },
    {
      keepPreviousData: true,
      enabled: !!customer_id, // Only run if customer_id exists
    }
  )

// Analytics & Business Intelligence Hooks

// Get customers summary with payment statistics
export const useCustomersSummary = (
  user_id: number,
  start_date: Date,
  end_date: Date,
  start_limit: number = 0,
  paginationsize: number = 10,
  status: string = '%'
) =>
  useQuery(
    ['customersSummary', user_id, start_date, end_date, start_limit, paginationsize, status],
    () => {
      return getCustomersSummary(user_id, start_date, end_date, start_limit, paginationsize, status)
    },
    {
      keepPreviousData: true,
      enabled: !!start_date && !!end_date, // Only run if dates are provided
    }
  )

// Get top customers by various metrics
export const useTopCustomers = (
  user_id: number,
  start_date: string,
  end_date: string,
  limit: number = 10,
  sort_by: 'total_sales' | 'unpaid_amount' | 'invoice_count' = 'total_sales'
) =>
  useQuery(
    ['topCustomers', user_id, start_date, end_date, limit, sort_by],
    () => {
      return getTopCustomers(user_id, start_date, end_date, limit, sort_by)
    },
    {
      keepPreviousData: true,
      enabled: !!start_date && !!end_date, // Only run if dates are provided
    }
  )

// Utility Hooks for Common Customer Operations

// Get customers with unpaid amounts only
export const useCustomersWithUnpaidAmounts = (
  user_id: number,
  start_limit: number = 0,
  paginationsize: number = 10,
  search_item: string = ''
) =>
  useQuery(
    ['customersWithUnpaid', user_id, start_limit, paginationsize, search_item],
    () => {
      return getCustomersWithUnpaidAmounts(user_id, start_limit, paginationsize, search_item)
    },
    {
      keepPreviousData: true,
    }
  )

// Get customer details with all invoice information
export const useCustomerFullDetails = (user_id: number, customer_id: number) =>
  useQuery(
    ['customerFullDetails', customer_id],
    () => {
      return getCustomerFullDetails(user_id, customer_id)
    },
    {
      keepPreviousData: true,
      enabled: !!customer_id, // Only run if customer_id exists
    }
  )

// Get customers sorted by unpaid amounts (highest first)
export const useCustomersByUnpaidAmount = (
  user_id: number,
  start_date: string,
  end_date: string,
  limit: number = 20
) =>
  useQuery(
    ['customersByUnpaid', user_id, start_date, end_date, limit],
    () => {
      return getCustomersByUnpaidAmount(user_id, start_date, end_date, limit)
    },
    {
      keepPreviousData: true,
      enabled: !!start_date && !!end_date, // Only run if dates are provided
    }
  )

// Get most active customers by invoice count
export const useMostActiveCustomers = (
  user_id: number,
  start_date: string,
  end_date: string,
  limit: number = 10
) =>
  useQuery(
    ['mostActiveCustomers', user_id, start_date, end_date, limit],
    () => {
      return getMostActiveCustomers(user_id, start_date, end_date, limit)
    },
    {
      keepPreviousData: true,
      enabled: !!start_date && !!end_date, // Only run if dates are provided
    }
  )

// Customer mutations
export const useCreateCustomer = (customerData: {
  customer_firstname: string
  customer_secondname: string
  customer_phone_number?: string
  customer_email?: string
  user_id: number
}) =>
  useMutation('createcustomer', () => {
    return createCustomer(customerData)
  })

export const useUpdateCustomer = (
  customer_id: number,
  updateData: {
    customer_firstname?: string
    customer_secondname?: string
    customer_phone_number?: string
    customer_email?: string
    user_id: number
  }
) =>
  useMutation('updatecustomer', () => {
    return updateCustomer(customer_id, updateData)
  })

export const useDeleteCustomer = (customer_id: number, user_id: number) =>
  useMutation('deletecustomer', () => {
    return deleteCustomer(customer_id, user_id)
  })

// ===============================
// USER MANAGEMENT HOOKS
// ===============================

export const useUserroles = (user_role_id: number) =>
  useQuery(
    'userroles',
    () => {
      return getUserrole(Number(user_role_id))
    },
    {
      keepPreviousData: true,
    }
  )

// ===============================
// PAYMENT AND MPESA HOOKS
// ===============================

export const useAllpaymenttypes = () =>
  useQuery(
    'allpaymenttypes',
    () => {
      return getPaymentType()
    },
    {
      keepPreviousData: true,
    }
  )

export const useMpesaBalances = () =>
  useQuery(
    'allmpesabalances',
    () => {
      return getMpesaBalance()
    },
    {
      keepPreviousData: true,
    }
  )

export const useMpesaTransactions = (
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery(['mpesatransactions', start_limit, paginationsize], () => {
    return getDailyMpesaTransactions(
      start_date,
      end_date,
      start_limit,
      paginationsize,
      itemto_order,
      desorasc,
      search_item
    )
  })

export const useMpesaTransactions2 = (
  start_date: Date,
  end_date: Date,
  start_limit: number,
  paginationsize: number,
  itemto_order: string,
  desorasc: string,
  search_item: string
) =>
  useQuery('mpesatransactions2', () => {
    return getDailyMpesaTransactions2(
      start_date,
      end_date,
      start_limit,
      paginationsize,
      itemto_order,
      desorasc,
      search_item
    )
  })

// Payment mutations
export const usePaymentrequest = (requestdetails: any) =>
  useMutation('usepaymentrequest', () => {
    return paymentRequest(requestdetails)
  })

export const useStatusrequest = (statusdetails: any) =>
  useMutation('usestatusrequest', () => {
    return statusRequest(statusdetails)
  })
